import React from 'react';
import { Result, Space } from 'antd';
import { useIntl } from 'react-intl';
import AccionaButton from '../../../../../../../../components/AccionaButton';
import PropTypes from 'prop-types';

const SuccessPage = ({
  checkDiffTemplate,
  onBackToOcr,
  onSaveTemplate,
  title,
  subtitle,
}) => {
  const intl = useIntl();
  return (
    <Result
      status="success"
      title={
        checkDiffTemplate
          ? intl.formatMessage({ id: 'successPage.templateModified.title' })
          : title
      }
      subTitle={
        checkDiffTemplate ? (
          <p style={{ fontSize: '18px' }}>
            {intl.formatMessage({
              id: 'successPage.templateModified.subtitle',
            })}
          </p>
        ) : (
          <p style={{ fontSize: '18px' }}>{subtitle}</p>
        )
      }
      extra={
        checkDiffTemplate ? (
          <Space>
            <AccionaButton
              type="primary"
              onClick={onBackToOcr}
              classIcon="fas fa-chevron-left"
              msg={intl.formatMessage({
                id: 'successPage.button.goToTemplates',
              })}
            />
            <AccionaButton
              onClick={onSaveTemplate}
              msg={intl.formatMessage({
                id: 'successPage.button.editTemplate',
              })}
              classIcon="fas fa-save"
            />
          </Space>
        ) : (
          <AccionaButton
            type="primary"
            onClick={onBackToOcr}
            classIcon="fas fa-chevron-left"
            msg={intl.formatMessage({ id: 'successPage.button.goToList' })}
          />
        )
      }
    />
  );
};

SuccessPage.propTypes = {
  checkDiffTemplate: PropTypes.bool.isRequired,
  onBackToOcr: PropTypes.func.isRequired,
  onSaveTemplate: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node.isRequired,
};

export default SuccessPage;
